export class TrainingSessionParticipants {
	Id: number;
	Name: string;
	Mark: ParticipantMark;
	FailedReasonId: number;
}

export enum ParticipantMark {
	NotComplete = "NotComplete",
	Fail = "Fail",
	Pass = "Pass",
}
